<template>
  <div>
    <div class="tabs">
      <ul>
        <router-link to="/stats/profit" tag="li" active-class="is-active">
          <a>Profit</a>
        </router-link>
        <router-link to="/stats/profitMultiple" tag="li" active-class="is-active">
          <a>Profit (Multiple)</a>
        </router-link>
        <router-link to="/stats/games" tag="li" active-class="is-active">
          <a>Games</a>
        </router-link>
        <router-link to="/stats/taxes" tag="li" active-class="is-active">
          <a>Taxes</a>
        </router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'stats'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/stats/index.vue